<template>
	<div class="detail">
		<div class="header">
			<div class="left" @click="goBack()">&lt;返回</div>
			<div class="span1">
				<span>作业详情</span>
			</div>
			<div class="right"></div>
		</div>
		<div class="main" v-loading="loading">
			<div class="main-title">
				<img src="./img/title-1.svg" alt="" />
				<p>作业详情</p>
			</div>
			<div class="main-li">
				<p>发布人</p>
				<span>{{ detail.createName }}</span>
			</div>
			<div class="main-li">
				<p>作业日期</p>
				<span>{{ detail.homeworkDate }}</span>
			</div>
			<div class="main-li">
				<p>登记时间</p>
				<span>{{ detail.createTime }}</span>
			</div>
			<div class="main-li">
				<p>发布时间</p>
				<span>{{ detail.createTime }}</span>
			</div>
			<div class="main-li">
				<p>作业标题</p>
				<span>{{ detail.title }}</span>
			</div>
			<div class="main-li">
				<p>完成期限</p>
				<span>{{ detail.deadline }}</span>
			</div>
			<div class="main-li">
				<p>预计完成时间</p>
				<span>{{ detail.estimateDuration }}分钟</span>
			</div>
			<div class="main-li">
				<p>作业内容</p>
				<span>{{ detail.content }}</span>
			</div>
			<div class="main-li">
				<p>附件</p>

				<ul class="file-detail" v-if="detail.resources && detail.resources.length">
					<li
						v-for="(item, i) in detail.resources"
						:key="i + '作业附件'"
						class="file-item"
						@click="previewUrl(item)"
					>
						<div>
							<img :src="ShowImg(item.ext)" class="img-icon" />
							<span>{{ item.name }}</span>
						</div>
					</li>
				</ul>
				<span v-else>暂无附件</span>
			</div>
			<div class="main-li">
				<p>设计意图</p>
				<span v-if="detail.purpose">{{ detail.purpose }}</span>
				<span v-else>暂无内容</span>
			</div>

			<div class="main-title" style="margin-top:50px">
				<img src="./img/title-2.svg" alt="" />
				<p>评审记录</p>
			</div>
			<div class="handle">
				<div class="handle-header">
					<span>操作</span>
					<p>审核时间</p>
				</div>
				<div v-for="(item, i) in handleList" :key="i" class="">
					<div class="handle-item">
						<img src="./img/reject.svg" alt="" v-if="item.reviewResult == 2" />
						<img src="./img/pass.svg" alt="" v-if="item.type == 'T1' || item.reviewResult == 0" />
						<img src="./img/success.svg" alt="" v-if="item.reviewResult == 11" />
						<div class="handle-mind">
							<img src="./img/user-1.svg" alt="" />
							<div class="handle-title">
								<p :class="{ blue: item.type == 'G3' }">{{ formatType(item) }}</p>
								<p class="text">{{ item.type == "S1" ? "系统自动审核" : item.feedback }}</p>
							</div>
						</div>
						<span class="handle-time">
							{{ item.type == "T1" ? "登记时间" : "审核时间" }}：{{ formatTime(item.operateTime) }}
						</span>
						<div
							class="line"
							v-if="i < handleList.length - 1 || (item.reviewResult == '2' && toModify)"
						></div>
					</div>
					<p class="handle-user">{{ item.operatorName }}</p>
				</div>
				<div class="handle-item" v-if="result == '2' && toModify">
					<img src="./img/pass.svg" alt="" />
					<div class="handle-mind">
						<img src="./img/user-1.svg" alt="" />
						<div class="handle-title">
							<p class="to-change" @click="toChange(detail.homeworkId)">去修改</p>
						</div>
					</div>
				</div>
				<p class="handle-user" v-if="result == '2' && toModify">{{ detail.createName }}</p>
			</div>
		</div>
		<div v-if="showCheckArea">
			<div class="main-title" style="margin-top:50px">
				<img src="./img/title-3.svg" alt="" />
				<p>评审反馈</p>
			</div>
			<el-input
				style="margin-top:20px"
				type="textarea"
				resize="none"
				:rows="6"
				placeholder="请输入"
				v-model="textarea"
			>
			</el-input>
			<footer>
				<el-button size="small" @click="check(detail, 2)">审核不通过</el-button>
				<el-button type="primary" size="small" @click="check(detail, 11)">审核通过</el-button>
			</footer>
		</div>
		<!-- 预览弹框 -->
		<el-dialog
			:visible.sync="dialogVisible"
			custom-class="preview-dialog center"
			:append-to-body="true"
		>
			<img class="close-image" @click="dialogVisible = false" src="./img/close-image.png" />
			<img v-if="fileType == 'image'" class=" preview-img center" :src="fileMsg.previewUrl" />
			<video
				v-else-if="fileType == 'video'"
				controls
				preload="metadata"
				class="preview-img center"
				:src="fileMsg.previewUrl"
			></video>

			<audio
				style="width:80%"
				v-else-if="fileType == 'audio'"
				controls
				preload="metadata"
				class="preview-img center"
				:src="fileMsg.previewUrl"
			></audio>
		</el-dialog>
	</div>
</template>
<script>
	import { getHwDetail, fetchReviewList, HwAudit } from "@/api/school/index.js";
	import dayjs from "dayjs";

	export default {
		components: {},
		data() {
			return {
				loading: true,
				detail: {},
				handleList: [],
				result: "", //评审结果
				textarea: "",
				showCheckArea: false, // 是否显示审核区域
				dialogVisible: false, //弹框是否显示
				fileType: "", //文件类型
				fileMsg: {}, //点击的文件参数集合
				toModify: false,
			};
		},
		computed: {},
		created() {},
		activated() {
			let query = this.$route.query;
			console.log("query--", query);
			this.showCheckArea = query.showCheckArea;
			this.jobType = query.jobType;
			this.toModify = query.toModify;
			this.fetchHwDetail(query.homeworkId);
			this.getReviewList(query.homeworkId);
		},
		deactivated() {
			this.$destroy();
		},
		mounted() {},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			// 预览附件
			previewUrl(item) {
				this.fileMsg = item;
				// console.log("item---", item);
				this.fileType = this.UseFileType(
					this.uploadType,
					this.UseFileType(this.suffixType, item.ext),
				);
				// console.log("this.fileType--", this.fileType);
				if (this.fileType === "image" || this.fileType === "video" || this.fileType === "audio") {
					this.dialogVisible = true;
				} else {
					window.open(item.previewUrl);
				}
			},
			//审核不通过去修改作业
			toChange(homeworkId) {
				this.$router.push({
					path: "/task/register/add",
					query: { id: homeworkId, flag: "modify" },
				});
			},
			// 查询作业详情
			async fetchHwDetail(id) {
				console.log("id--", id);
				this.loading = true;
				let params = {
					homeworkId: id,
				};
				const res = await getHwDetail(params);
				console.log("查详情--", res);
				res.createTime = dayjs(res.createTime).format("YYYY-MM-DD HH:mm");
				res.deadline = dayjs(res.deadline).format("YYYY-MM-DD HH:mm");
				res.homeworkDate = dayjs(res.homeworkDate).format("YYYY-MM-DD");
				this.loading = false;
				if (!res) return;
				this.detail = res;
			},
			//查询评审列表
			async getReviewList(id) {
				let params = {
					homeworkId: id,
				};
				const res = await fetchReviewList(params);
				console.log("查作业审核信息列表--", res);
				if (!res) return;
				this.handleList = res;
				this.result = this.handleList[this.handleList.length - 1].reviewResult;
			},
			// 作业审核
			async check(item, state) {
				console.log("item--", { ...item });
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkId: item.homeworkId,
					feedback: this.textarea,
					state,
					jobType: this.jobType,
				};
				console.log("审核--", params);
				const res = await HwAudit(params);
				console.log("审核是否成功--", res);
				if (!res) return;
				this.goBack();
			},
			formatType(item) {
				let obj = {
					T1: "作业登记",
					// S1: '系统自动评审',
					G1: "【学科组长】",
					G2: "【年级组长】",
					G3: "【管理员】",
					11: "审核通过",
					2: "审核不通过",
				};
				return `${obj[item.type] || ""} ${obj[item.reviewResult] || ""}`;
			},
			formatTime(time) {
				return dayjs(time).format("YYYY.MM.DD HH: mm");
			},
			reject() {},
			pass() {},
		},
	};
</script>
<style lang="less" scoped>
	.detail {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 60px;
			line-height: 48px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #eee;
			align-items: center;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				font-size: 14px;
				color: #8b8b8b;
				cursor: pointer;
			}
		}
		.main-title {
			display: flex;
			align-items: center;
			p {
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
		.main {
			width: 100%;
			height: 100%;

			.main-li {
				margin-top: 20px;
				width: 100%;
				display: flex;
				// align-items: center;
				font-size: 14px;
				color: #888;
				p {
					width: 120px;
					text-align: right;
					margin-right: 20px;
				}
				span {
					width: calc(100% - 150px);
					word-wrap:break-word;
				}
			}
		}

		.file-detail {
			width: 100%;
			.file-item {
				width: 233px;
				height: 50px;
				line-height: 50px;
				border-radius: 4px;
				background: #f4f9ff;
				position: relative;
				display: inline-block;
				margin-right: 20px;
				margin-bottom: 10px;
				text-align: center;
				font-size: 14px;
				color: #333;
				cursor: pointer;
				div {
					display: flex;
					align-items: center;
					.img-icon {
						margin-left: 10px;
						width: 36px;
						height: 40px;
					}
					span {
						margin-left: 10px;
						width: 300px;
						text-align: left;
						// 省略号
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.handle-header {
			display: flex;
			padding-left: 80px;
			margin-top: 20px;
			span {
				width: calc(60% + 53px);
			}
		}
		.handle-item {
			width: 100%;
			height: 50px;
			margin-top: 30px;
			font-size: 14px;
			display: flex;
			align-items: center;
			padding-left: 80px;
			position: relative;
			.line {
				position: absolute;
				width: 1px;
				height: calc(100% + 10px);
				background: #eeeeee;
				left: 90px;
				top: calc(50% + 10px);
			}

			.handle-mind {
				width: 60%;
				margin-left: 15px;
				display: flex;
				align-items: center;
				.handle-title {
					margin-left: 20px;
					.text {
						color: #999999;
						margin-top: 2px;
					}
					.to-change {
						color: #4991e1;
						cursor: pointer;
					}
				}
				.blue {
					color: #4991e1;
				}
			}
			.handle-time {
				margin-left: 20px;
				color: #999999;
			}
		}
		.handle-user {
			color: #666666;
			padding-left: 112px;
		}
	}
	footer {
		margin-top: 50px;
		display: flex;
		justify-content: center;
		.el-button {
			width: 120px;
			&:last-child {
				margin-left: 20px;
			}
		}
	}
	::v-deep .preview-dialog {
		width: 800px;
		height: 450px;
		margin-top: 0 !important;
		margin: 0;
		.preview-img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
			flex-grow: 0;
		}
		.close-image {
			position: absolute;
			top: -26px;
			right: -26px;
			width: 58px;
			height: 58px;
			z-index: 99;
		}
	}
	::v-deep .el-dialog__header {
		padding: 0;
	}
	::v-deep .el-dialog__body {
		// position: relative;
		padding: 0;
		width: 100%;
		height: 100%;
	}
	::v-deep .el-dialog__headerbtn .el-dialog__close {
		display: none;
	}
</style>
